<div class="flex flex-col gap-6">
  <p class="m-0 inline-flex w-fit items-center rounded-full bg-emerald-50 px-3 py-1.5 text-sm font-bold text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200">
    Agency created · 14-day trial started
  </p>

  @if (onboarding.draft().createdBrands.length > 0) {
    <div class="flex flex-col gap-3">
      <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
        Which brand are you <span class="text-primary">briefing first?</span>
      </h1>
      <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">We'll open that brand's workspace. You can brief the others any time.</p>
    </div>

    <div class="flex flex-col gap-2" role="radiogroup" aria-label="Brand to open first">
      @for (brand of onboarding.draft().createdBrands; track brand.id; let index = $index) {
        <button
          type="button"
          role="radio"
          [class]="selected(index) ? 'flex min-h-16 w-full items-center gap-3 rounded-xl border-2 border-primary bg-primary/10 p-3 text-left' : 'flex min-h-16 w-full items-center gap-3 rounded-xl border border-border bg-card p-3 text-left'"
          [attr.aria-checked]="selected(index)"
          (click)="choose(index)">
          @if (brand.logoUrl) {
            <img [src]="imageService.getImageSource(brand.logoUrl, 'gallery')" alt="" class="size-10 shrink-0 rounded-lg bg-muted object-cover" />
          } @else {
            <span class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-linear-to-br from-brand-agency-dark to-brand-agency text-sm font-black text-white" aria-hidden="true">{{ brand.name.charAt(0) }}</span>
          }
          <div class="min-w-0 flex-1">
            <p class="m-0 truncate text-lg font-bold">{{ brand.name }}</p>
            <p class="m-0 truncate text-base font-semibold text-muted-foreground">{{ domainLabel(brand.domain) }}</p>
          </div>
          <span
            class="flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-bold"
            [class]="selected(index) ? 'border border-primary bg-primary text-primary-foreground' : 'border border-border'"
            aria-hidden="true">
            @if (selected(index)) {
              ✓
            }
          </span>
        </button>
      }
    </div>

    <div class="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-background px-5 py-3 sm:static sm:z-auto sm:border-0 sm:bg-transparent sm:p-0">
      <button type="button" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" (click)="start()">
        {{ startLabel() }}
      </button>
      <button type="button" class="mt-3 w-full text-center text-base font-bold text-primary" (click)="skip()">Skip to dashboard</button>
    </div>
  } @else {
    <div class="flex flex-col gap-3">
      <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
        Your agency is <span class="text-primary">live</span>
      </h1>
      <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">Add your first brand from the dashboard to start briefing creators.</p>
    </div>
    <div class="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-background px-5 py-3 sm:static sm:z-auto sm:border-0 sm:bg-transparent sm:p-0">
      <button type="button" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" (click)="skip()">
        Go to dashboard →
      </button>
    </div>
  }
</div>
